import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const Terminos = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <Helmet>
        <title>Directorio de Salud y Bienestar - Términos y Condiciones | MedicinPro</title>
        <meta name="description" content="Términos y condiciones de uso del directorio médico MedicinPro." />
      </Helmet>
      
      <h1 className="text-3xl font-bold mb-6">Términos y Condiciones de Uso</h1>
      
      <p className="mb-4 text-gray-600">Última actualización: 25 de enero de 2024</p>

      <div className="space-y-6">
        <section>
          <h2 className="text-xl font-semibold mb-3">1. Aceptación de los Términos</h2>
          <p className="text-gray-700">
            Al acceder y utilizar MedicinPro, usted acepta estar sujeto a estos Términos y Condiciones. Si no está de acuerdo con alguna parte de los términos, no debe utilizar nuestros servicios.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">2. Uso del Servicio</h2>
          <p className="text-gray-700 mb-2">
            MedicinPro proporciona información de profesionales y centros de salud con fines informativos. No sustituye el consejo médico profesional.
          </p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>No se garantiza la exactitud ni actualización de la información</li>
            <li>Los usuarios deben verificar directamente con los profesionales</li>
            <li>Prohibido el uso comercial no autorizado</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">3. Responsabilidades del Usuario</h2>
          <p className="text-gray-700">
            Los usuarios se comprometen a:
          </p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>Utilizar la plataforma solo para fines legales</li>
            <li>No realizar actividades que comprometan la seguridad del sistema</li>
            <li>No difundir información falsa o engañosa</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">4. Privacidad</h2>
          <p className="text-gray-700">
            La protección de datos personales se rige por nuestra <Link to="/privacidad" className="text-primary-600 hover:underline">Política de Privacidad</Link>.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">5. Limitación de Responsabilidad</h2>
          <p className="text-gray-700">
            MedicinPro no será responsable por:
          </p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>Decisiones médicas tomadas en base a la información proporcionada</li>
            <li>Interrupciones temporales del servicio</li>
            <li>Contenido publicado por terceros</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">6. Modificaciones</h2>
          <p className="text-gray-700">
            Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigor inmediatamente después de su publicación.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">7. Ley Aplicable</h2>
          <p className="text-gray-700">
            Estos términos se rigen por las leyes de México y cualquier disputa se resolverá en los tribunales competentes de la Ciudad de México.
          </p>
        </section>
      </div>

      <div className="mt-8 border-t pt-4">
        <p className="text-gray-600">
          Para preguntas sobre estos términos, contacte a: info@medicinpro.com
        </p>
        <Link to="/" className="mt-4 inline-block text-primary-600 hover:underline">
          ← Volver al inicio
        </Link>
      </div>
    </div>
  );
};

export default Terminos;